/* Draft product copy presentation. Catalog text remains the source of truth. */
(function () {
  'use strict';
  var headingSelector = 'h1,h2,h3,h4,h5,h6';
  function text(node) { return (node.textContent || '').replace(/\s+/g, ' ').trim(); }
  function isContents(node) {
    return /^(contents of purchase|package contents|what[’']?s included|what[’']?s in the box|included in (the )?box)\s*[:?]?$/i.test(text(node));
  }
  function section(title, body) {
    var details = document.createElement('details');
    details.className = 'rcm-copy-section';
    var summary = document.createElement('summary');
    while (title.firstChild) summary.appendChild(title.firstChild);
    details.appendChild(summary);
    body.className = 'rcm-copy-body';
    body.removeAttribute('style');
    details.appendChild(body);
    return details;
  }
  function normalize(copy) {
    if (copy.dataset.rcmReady) return;
    copy.dataset.rcmReady = 'true';
    /* Restore semantics before removing legacy presentation attributes. */
    Array.from(copy.querySelectorAll('button.accordion,.accordion-header')).reverse().forEach(function (title) {
      var anchor = title;
      if (title.parentElement.tagName === 'P' && title.parentElement.children.length === 1 && text(title.parentElement) === text(title)) anchor = title.parentElement;
      var panel = anchor.nextElementSibling;
      if (panel && panel.matches('.panel,.accordion-content')) {
        var marker = document.createComment('description section');
        anchor.before(marker);
        var details = section(title, panel);
        if (title.id) details.querySelector('summary').id = title.id;
        anchor.remove(); marker.replaceWith(details);
      } else if (title.tagName === 'BUTTON') {
        var heading = document.createElement('h3');
        while (title.firstChild) heading.appendChild(title.firstChild);
        title.replaceWith(heading);
      }
    });
    copy.querySelectorAll('h1').forEach(function (old) {
      var heading = document.createElement('h2');
      if (old.id) heading.id = old.id;
      while (old.firstChild) heading.appendChild(old.firstChild);
      old.replaceWith(heading);
    });
    copy.querySelectorAll('table').forEach(function (table) {
      var rows = Array.from(table.rows);
      var grades = /like new|excellent|\bgood\b|\bfair\b|open box|lightly used/i;
      if (rows.length === 2 && rows[0].cells.length >= 2 && rows[0].cells.length === rows[1].cells.length && Array.from(rows[0].cells).every(function (cell) { return grades.test(text(cell)); }) && !table.querySelector('[colspan],[rowspan],caption')) {
        var grid = document.createElement('div'); grid.className = 'rcm-copy-grades';
        Array.from(rows[0].cells).forEach(function (cell, i) {
          var card = document.createElement('article'); card.className = 'rcm-copy-grade';
          var h = document.createElement('h4'); while (cell.firstChild) h.appendChild(cell.firstChild);
          var body = document.createElement('div'); var source = rows[1].cells[i];
          while (source.firstChild) body.appendChild(source.firstChild);
          card.append(h, body); grid.appendChild(card);
        });
        table.replaceWith(grid);
      } else {
        var scroll = document.createElement('div'); scroll.className = 'rcm-copy-table';
        scroll.tabIndex = 0; scroll.setAttribute('role', 'region'); scroll.setAttribute('aria-label', 'Product information table');
        table.before(scroll); scroll.appendChild(table);
      }
    });
    copy.querySelectorAll('h4').forEach(function (h) {
      if (!/like new|excellent|\bgood\b|\bfair\b|open box|lightly used/i.test(text(h))) return;
      var card = h.parentElement, group = card.parentElement;
      if (card.tagName !== 'DIV' || !group || group === copy) return;
      var cards = Array.from(group.children);
      if (cards.length >= 2 && cards.every(function (item) { return item.tagName === 'DIV' && item.querySelector('h4'); })) {
        group.classList.add('rcm-copy-grades');
        cards.forEach(function (item) { item.classList.add('rcm-copy-grade'); });
      }
    });
    copy.querySelectorAll('*').forEach(function (el) {
      /* Descriptions do not control page fonts, spacing, fixed widths or visibility. */
      el.removeAttribute('style'); el.removeAttribute('align');
      if (!el.matches('img,video,iframe,svg,path')) { el.removeAttribute('width'); el.removeAttribute('height'); }
      ['accordion','accordion-header','accordion-content','panel','active','perfect-box','rx-acc','rx-panel','product-single__description','rte'].forEach(function (name) { el.classList.remove(name); });
      if (el.tagName === 'DETAILS') el.classList.add('rcm-copy-section');
    });
    /* Empty imported paragraphs are spacing, not product copy. */
    copy.querySelectorAll('p').forEach(function (p) {
      if (!text(p) && !p.querySelector('img,iframe,video,a,svg,input')) p.remove();
    });
  }
  function contents(copy) {
    var headings = Array.from(copy.querySelectorAll('summary,' + headingSelector + ',p,strong,b'));
    var h = headings.find(isContents);
    if (!h) return [];
    if (h.tagName === 'STRONG' || h.tagName === 'B') {
      if (h.parentElement !== copy && text(h.parentElement) === text(h)) h = h.parentElement;
    }
    var nodes = [];
    if (h.tagName === 'SUMMARY') nodes = Array.from(h.parentElement.children).filter(function (n) { return n !== h; });
    else {
      var next = h.nextElementSibling;
      while (next) {
        if (next.matches(headingSelector + ',details,summary') || next.querySelector(headingSelector + ',details,summary')) break;
        nodes.push(next); next = next.nextElementSibling;
      }
    }
    var lines = [];
    nodes.forEach(function (node) {
      var chunks = node.querySelectorAll('li,p');
      if (!chunks.length) chunks = [node];
      Array.from(chunks).forEach(function (chunk) {
        if (chunk.tagName === 'LI' && chunk.querySelector('p')) return;
        var value = text(chunk).replace(/^[•\s]+/, '');
        if (value && lines.indexOf(value) === -1) lines.push(value);
      });
    });
    /* Refuse ambiguous imports instead of leaking another section into the box. */
    if (lines.join(' ').length > 1200 || lines.some(function (line) { return /condition guide|shipping (and|&) returns/i.test(line); })) return [];
    return lines;
  }
  function init(root) {
    root.querySelectorAll('[data-rcm-description]').forEach(function (copy) {
      normalize(copy);
      var scope = copy.closest('[data-section-type="product-template"]');
      if (!scope) return;
      var lines = contents(copy);
      if (!lines.length) return;
      scope.querySelectorAll('[data-rcm-box]').forEach(function (box) {
        var list = box.querySelector('[data-rcm-box-list]');
        list.replaceChildren(); lines.forEach(function (value) { var li = document.createElement('li'); li.textContent = value; list.appendChild(li); });
        var fallback = box.querySelector('[data-rcm-box-fallback]'); if (fallback) fallback.hidden = true;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
